import { Download, ExternalLink, FileText, Film, PlayCircle } from "lucide-react";
import { toast } from "sonner";

const kb = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export const downloadBlob = async (api, url, fallbackName) => {
  try {
    const res = await api.get(url, { responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
    const a = document.createElement("a"); a.href = URL.createObjectURL(res.data); a.download = name; a.click();
  } catch (err) {
    const text = err.response?.data instanceof Blob ? JSON.parse(await err.response.data.text()).detail : err.response?.data?.detail;
    toast.error(text || "Download failed");
  }
};

const API = process.env.REACT_APP_BACKEND_URL;
const isVideo = (r) => r.is_video || /\.(mp4|mov|m4v|webm)$/i.test(r.filename || "");
const fileUrl = (r, inline) => `${API}/api/lms/learner/materials/${r.id}/file${inline ? "?inline=true" : ""}`;
const btn = "inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-medium";

export const ResourceList = ({ resources, showLesson = false }) => {
  if (!resources?.length) return <p className="text-sm italic text-slate-500">No materials yet.</p>;
  return (
    <ul className="divide-y divide-slate-100 rounded-xl border border-border bg-white" data-testid="resource-list">
      {resources.map((r) => (
        <li key={r.id} className="flex items-center gap-3 px-4 py-3" data-testid={`resource-${r.id}`}>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-700">{r.kind === "link" ? <ExternalLink size={16} /> : isVideo(r) ? <Film size={16} /> : <FileText size={16} />}</span>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-slate-900">{r.title}</p>
            <p className="text-[11px] text-slate-500">{showLesson && r.lesson_title ? `${r.lesson_title} · ` : ""}{r.kind === "link" ? "External link" : `${(r.filename || "").split(".").pop()?.toUpperCase()} · ${kb(r.size || 0)}`}</p>
          </div>
          {r.kind === "link" ? (
            <a href={r.url} target="_blank" rel="noreferrer" className={`${btn} border border-border hover:bg-slate-50`} data-testid={`resource-open-${r.id}`}>Open</a>
          ) : (
            <div className="flex gap-1.5">
              {isVideo(r) && <a href={fileUrl(r, true)} target="_blank" rel="noreferrer" className={`${btn} border border-border hover:bg-slate-50`} data-testid={`resource-watch-${r.id}`}><PlayCircle size={12} /> Watch</a>}
              <a href={fileUrl(r, false)} className={`${btn} bg-blue-600 text-white hover:bg-blue-700`} data-testid={`resource-download-${r.id}`}><Download size={12} /> Download</a>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};
